import React, { useEffect } from 'react';
import { LoginForm, TextInput, required, useCheckAuth } from 'react-admin';
import { Button, Divider, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getEnv } from '@src/apis/shared';
import { AuthLayout } from './AuthLayout';

/*
 * Custom /login page (badge sign-in), styled to the Slate Ink theme via the
 * shared <AuthLayout> shell (src/components/AuthLayout.tsx). Auth wiring is
 * unchanged: react-admin's <LoginForm> (badge credential) plus the Okta SSO
 * handoff to /sso. The redirect-if-already-authenticated effect replicates what
 * react-admin's default <Login> wrapper did for us before.
 */

const OktaSignInButton = () => {
  const navigate = useNavigate();
  const oktaConfigured = !!(getEnv('OKTA_BASE_URI') && getEnv('OKTA_CLIENT_ID'));
  if (!oktaConfigured) return null;

  return (
    <>
      <Divider sx={{ my: 2.5 }}>
        <Typography variant="caption" color="text.secondary" sx={{ px: 1 }}>
          or
        </Typography>
      </Divider>
      <Button fullWidth variant="outlined" sx={{ height: 44 }} onClick={() => navigate('/sso')}>
        Sign in with SSO
      </Button>
    </>
  );
};

const CustomLogin = () => {
  const checkAuth = useCheckAuth();
  const navigate = useNavigate();
  useEffect(() => {
    // Already authenticated → straight to the app (mirrors react-admin's <Login>).
    checkAuth({}, false)
      .then(() => navigate('/'))
      .catch(() => {
        /* not authenticated — stay on the login page */
      });
  }, [checkAuth, navigate]);

  return (
    <AuthLayout
      heading="Welcome to Trove Dashboard"
      subcopy="Sign in to manage your recommerce programs."
    >
      <LoginForm
        sx={{
          '& .RaLoginForm-content': { width: '100%', p: 0, pb: '0 !important' },
          '& .RaLoginForm-button': { mt: 1.5, height: 44, fontSize: 15 },
        }}
      >
        <TextInput
          autoFocus
          source="badge"
          label="Badge"
          autoComplete="off"
          validate={required()}
          fullWidth
        />
      </LoginForm>

      <OktaSignInButton />
    </AuthLayout>
  );
};

export default CustomLogin;
